










































import ICivilization from '@/ICivilization'
import Vue from 'vue'

export default Vue.extend({
  name: 'Navbar',
  data () {
    return {
      civFilter: '',
      collapsed: false
    }
  },
  computed: {
    civilizations (): ICivilization[] {
      return this.$store.state.civilizations
    },
    filteredCivilizations (): ICivilization[] {
      return this.civilizations.filter(civ => civ.name.toLowerCase().includes(this.civFilter.toLowerCase()) || civ.leader.toLowerCase().includes(this.civFilter.toLowerCase()))
      // return this.civilizations.filter(civ => JSON.stringify(civ).toLowerCase().includes(this.civFilter.toLowerCase()))
    },
    receivedData (): boolean {
      return this.$store.state.receivedData
    }
  },
  created () {
    window.addEventListener('keydown', this.keydownEvent)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keydownEvent)
  },
  methods: {
    keydownEvent (e: KeyboardEvent) {
      // Don't capture special keys or spacebar, but capture backspace
      if ((e.key.length > 1 || e.key === ' ') && e.key !== 'Backspace') return
      (this.$refs.search as HTMLInputElement).focus()
    }
  }
})
